/** Mirrors brand.css — use in JSX/SVG where CSS variables are unavailable. */
export const brandPrimary = '#7500AB';
export const brandAccent = '#46C31E';
export const brandPlayer = '#E40A3B';
export const brandHighlight = '#FFE500';
export const brandUtility = '#0855F2';
export const brandPrimaryLight = '#E3CCEE';
export const brandAccentLight = '#DAF3D2';
export const brandAccentLightStrong = '#C7EDBB';
export const brandAccentAlpha50 = 'rgba(70, 195, 30, 0.5)';
export const chartRank1 = '#60C427';
export const chartRank2 = '#FFE500';
export const chartRank2Light = '#FEF5A3';
export const chartRankDefaultLight = '#BBA4D5';
export const chartRankDefault = '#7500AB';
export const colorWhite = '#FFFFFF';
export const colorBlack = '#000000';
